enum ItemRarity {
  Artifact = 'artifact',
  Common = 'common',
  Epic = 'epic',
  Legendary = 'legendary',
  Poor = 'poor',
  Rare = 'rare',
  Uncommon = 'uncommon',
}

export default ItemRarity
